import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { ApiResponse, sendBlockAndReportCharacter } from '~/api';
import {
  ApiError,
  EmptyObject,
  SendBlockAndReportCharacterRequest,
} from '~/types';
import useToast from '~/store/useToast';

const useBlockAndReportCharacterMutation = () => {
  const { showToast } = useToast();

  return useMutation<
    ApiResponse<EmptyObject>,
    ApiError,
    SendBlockAndReportCharacterRequest
  >({
    mutationFn: sendBlockAndReportCharacter,
    onError: (err) => {
      const error = err as ApiError;
      console.error(error);
      if (error.status === 409) {
        if (error.body.code === 0)
          showToast('error', 'You cannot block yourself.');
        else if (error.body.code === 1) {
          showToast('error', 'You have already blocked this character.');
        }
      } else {
        showToast('error', 'Failed to block and report character.');
      }
    },
  });
};

export default useBlockAndReportCharacterMutation;
